import { Link, useNavigate } from "react-router-dom";
import { AriaGridList, AriaGridListItem } from "@/components/ui/aria-gridlist";
import { WalkthroughItemContent } from "@/components/experience/walkthrough-item";
import { DashboardSectionHeader } from "./dashboard-section-header";
import type { WalkthroughListItem } from "./dashboard-types";

interface RecentWalkthroughsCardProps {
  projectId: string;
  walkthroughs: WalkthroughListItem[] | undefined;
}

export function RecentWalkthroughsCard({
  projectId,
  walkthroughs,
}: RecentWalkthroughsCardProps) {
  const navigate = useNavigate();

  if (!walkthroughs || walkthroughs.length <= 1) return null;

  // Skip the first (latest) since it's already shown in the hero above
  const rest = walkthroughs.slice(1, 8);

  return (
    <section>
      <DashboardSectionHeader
        kicker="Recent walkthroughs"
        note="Across scenarios and personas"
        action={
          <Link
            to={`/projects/${projectId}/walkthroughs`}
            className="whitespace-nowrap text-sm text-muted-foreground underline-offset-4 transition-colors hover:text-foreground hover:underline"
          >
            All walkthroughs →
          </Link>
        }
      />
      <AriaGridList
        aria-label="Recent walkthroughs"
        onAction={(key) =>
          navigate(`/projects/${projectId}/walkthroughs/${key}`)
        }
      >
        {rest.map((w) => (
          <AriaGridListItem
            key={w.id}
            id={w.id}
            textValue={w.scenarioName ?? "Walkthrough"}
          >
            <WalkthroughItemContent walkthrough={w} showScenario />
          </AriaGridListItem>
        ))}
      </AriaGridList>
    </section>
  );
}
